import React, {useMemo, useState} from 'react';
import {FormInputComponent} from "../../../components/form/Form";
import {Badge, Empty, Modal, Tabs, Radio, Input, InputNumber, Statistic} from "antd";
import {usePositionForm} from "../../../providers/PositionFormProvider";
import {useAuth} from "../../../providers/AuthProvider";
import {useAPI} from '../../../config/API';
import LoadingBanner from '../../../components/LoadingBanner';
import {useOutletContext} from "react-router-dom";
import PositionDeliverablesForm from "./PositionDeliverablesForm";
import ReactPortal from "../../../components/ReactPortal";
import AnimatedNumber from "animated-number-react";
import UserDiscipline from "../../../models/UserDiscipline";
import {useProject} from "../../../providers/ClientProjectProvider";
import {useProjectForm} from "../../../providers/ProjectFormProvider";
import {useDebounce} from "react-use";


const PositionFixedRetainerForm = props => {
    const {auth} = useAuth();

    const [editModalOpen, setEditModalOpen] = useState(false);

    const {onChange, isReadOnly: isContextReadOnly, isDisabled} = useOutletContext();

    const isReadOnly = isContextReadOnly || props.isReadOnly;
    const {
        project,
        formModel: projectFormModel
    } = useProjectForm();
    const {
        formModel: position,
        isProjectUpdating,
        onFormReset,
        hasFormBeenSubmitted
    } = usePositionForm();


    const frequencyDisplay = {
        'weekly': 'week',
        'monthly': 'month',
    }

    const [editingIndex, setEditingIndex] = useState(false)
    const [editingDeliverable, setEditingDeliverable] = useState(false)
    const [selectedTab, setSelectedTab] = useState('selected-deliverables')

    const positionDeliverables = position.deliverables || []
    const positionMarkup = position.percent_markup || projectFormModel.percent_markup || 0;

    const standardRate = useMemo(() => TB.max(
        TB.map(position.disciplines, dis => {
                return UserDiscipline.rateForDiscipline(dis.id, parseFloat(positionMarkup), true)
            }
        )), [position.disciplines]);


    const toggleDeliverableForm = async (isOpen) => {
        setEditModalOpen(isOpen)
    }
    const editDeliverable = async (deliverable) => {
        await setEditingDeliverable(deliverable)
        await TB.wait(200)

        console.log('editDeliverable', deliverable)
        return toggleDeliverableForm(true)
    }

    const addNewDeliverable = async () => {
        return editDeliverable({name: '', description: '', is_adding: true})
    }


    const startMinDate = useMemo(() => {
        if (auth?.canManageClients()) {
            return undefined
        }

        let minDate = new Date();

        if (position.started_at && TB.moment(position.started_at).clone().endOf('day').toDate() < minDate) {
            return TB.moment(position.started_at).clone().endOf('day').toDate()
        }

        return minDate;
    }, [position.start_date]);

    const getPeriodRetainer = () => {
        return position.isFixedRetainerRateBased() ? (position.target_rate * position.avg_hours_per_period) : (position.budget)
    }
    const [isLoadingPeriodRetainer, setIsLoadingPeriodRetainer] = useState(false);
    const [isLoadingTotalBudget, setIsLoadingTotalBudget] = useState(false);

    const [periodRetainer, setPeriodRetainer] = useState(getPeriodRetainer());

    const [totalBudget, setTotalBudget] = useState(position.calculateFixedRetainerBudget() || 0);
    const [, cancel] = useDebounce(
        () => {
            setIsLoadingPeriodRetainer(false);
            setIsLoadingTotalBudget(false);
            setPeriodRetainer(getPeriodRetainer());
            setTotalBudget(position.calculateFixedRetainerBudget() || 0);
        },
        1000,
        [
            position.actual_total_periods,
            position.payout_frequency,
            position.target_rate,
            position.avg_hours_per_period,
            position.budget
        ]
    );

    const onChangeBudgetInputs = async (changes) => {
        if ((position.isFixedRetainerRateBased() && (changes.target_rate || changes.avg_hours_per_period))
        || (!position.isFixedRetainerCostPerPeriodBased() && changes.budget)) {
            await setIsLoadingPeriodRetainer(true)
        }
        await setIsLoadingTotalBudget(true)
        onChange(changes)
    }
    const validDeliverables = TB.filter(positionDeliverables, del => del.name);

    const isRateBased = position.isFixedRetainerRateBased();
    const isCostPerPeriodBased = position.isFixedRetainerCostPerPeriodBased();

    const CurrentPositionDeliverables = (
        <div className="flex flex-col items-stretch gap-3 p-3 rounded-lg bg-gray-50">
            <p className="text-center underline">List of deliverables/activities</p>
            <div className="relative flex items-stretch justify-center flex-col">

                {!validDeliverables.length ? (
                    <div className="py-5 self-center relative flex items-stretch justify-center flex-col">
                        <Empty description="Your deliverables or activities will appear here"
                               image={Empty.PRESENTED_IMAGE_SIMPLE}>

                            {!isReadOnly && (
                                <button
                                    type="button"
                                    className="btn btn-primary self-center whitespace-nowrap mx-auto"
                                    onClick={addNewDeliverable}
                                >
                                    Add Deliverable or Activity
                                </button>
                            )}
                        </Empty>
                    </div>
                ) : (
                    <React.Fragment>
                        <div className="flex flex-col items-stretch divide-y gap-3 px-3">
                            {validDeliverables.map((deliverable, delIndex) => {
                                return (
                                    <div className="py-4 flex flex-row items-center gap-4" key={`del-${delIndex}`}>
                                        <p className="self-start">
                                            <i className={TB.mapClass("fas text-[26px]", {
                                                "fa-clipboard-check": true,//item.deliverable_id,
                                                // "fa-clipboard-list": !item.deliverable_id,
                                            })}/>
                                        </p>
                                        <div className="flex-grow flex flex-col gap-2">
                                            <p className="text-base whitespace-no-wrap font-semibold">
                                                {deliverable.name}
                                                {deliverable.deliverable_id ? (
                                                    <Badge className="ml-2" count="Selected"
                                                           style={{backgroundColor: TB.config('color.secondary')}}/>
                                                ) : ''}
                                            </p>

                                            <p className="text-sm line-clamp-5">
                                                {deliverable.description || (
                                                    <i>No Description Provided...</i>
                                                )}
                                            </p>
                                            <div className="relative flex flex-row items-start">
                                                <i className="text-sm far fa-sticky-note text-info mr-2"/>
                                                <p className="text-xs line-clamp-4 mt-0.5" title={deliverable.notes}>
                                                    {deliverable.notes ? (
                                                        <span>
                                                            <span className="font-semibold">
                                                                Notes:
                                                            </span>
                                                            &nbsp;
                                                            {deliverable.notes}
                                                        </span>
                                                    ) : (
                                                        <i>No Notes Provided...</i>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                        {!isReadOnly && (
                                            <div className="flex flex-col items-center justify-center gap-1">
                                                <button type="button"
                                                        className="btn btn-link btn-link-info whitespace-no-wrap px-0 py-0 min-w-[60px]"
                                                        onClick={() => {
                                                            return editDeliverable(deliverable)
                                                        }}>
                                                    Edit
                                                </button>
                                                <button type="button"
                                                        className="btn btn-link btn-link-danger px-0 py-0.5"
                                                        onClick={async () => {
                                                            let confirm = await TB.alert('error', 'Remove?',
                                                                'Are you sure you want to remove this deliverable?',
                                                                [
                                                                    {title: 'Yes, Continue'},
                                                                    {title: 'Cancel'}
                                                                ]
                                                            )

                                                            if (confirm) {
                                                                onChange({deliverables: positionDeliverables.filter(del => del.name !== deliverable.name)})
                                                            }
                                                        }}>
                                                    Remove
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                        {!isReadOnly && (
                            <button
                                type="button"
                                className="btn btn-primary self-center whitespace-nowrap mx-auto"
                                onClick={addNewDeliverable}
                                disabled={isProjectUpdating}
                            >
                                Add Deliverable or Activity
                            </button>
                        )}
                    </React.Fragment>
                )}
            </div>

        </div>
    )

    const tabs = [
        {
            key: 'selected-deliverables',
            label: 'Current Deliverables/Activities',
            children: CurrentPositionDeliverables
        },
    ]

    return (
        <div className="flex flex-col justify-start items-stretch self-stretch relative gap-3">


            <div className="flex flex-row items-center justify-start gap-6 mb-6">
                <p className="self-center text-base font-medium text-left text-[#3f434a]">
                    Desired Start date for this position:
                </p>
                <div className="flex flex-col items-stretch basis-1/3">
                    <FormInputComponent
                        className="mb-0"
                        fieldName="started_at"
                        label={false}
                        value={position.started_at}
                        type="date"
                        size="large"
                        isReadOnly={props.isReadOnly}
                        suffixIcon={props.isReadOnly ? null : undefined}
                        minDate={startMinDate}
                        required={true}
                        disabled={isDisabled || isProjectUpdating}
                        validateBeforeSubmit={false}
                    />
                </div>
            </div>
            <div className="flex flex-row items-center justify-start gap-6 mb-6">
                <p className="self-center text-base font-medium text-left text-[#3f434a]">
                    What type of retainer?
                </p>
                <div className="flex flex-col items-stretch basis-1/3">
                    <FormInputComponent
                        className="mb-0"
                        fieldName="payout_frequency"
                        value={position.payout_frequency}
                        isReadOnly={isReadOnly}
                        label={false}
                        type="antd-input"
                        required={true}
                        disabled={isProjectUpdating || isDisabled || !position.started_at}>

                        <Radio.Group
                            size="large"
                            options={[
                                {label: 'Weekly', value: 'weekly'},
                                {label: 'Monthly', value: 'monthly'},
                            ]}
                            className="flex flex-row gap-2"
                            optionType="button"
                            buttonStyle="solid"
                        />
                    </FormInputComponent>
                </div>
            </div>

            <div className="flex flex-row items-center justify-start gap-6 mb-6">
                <p className="self-center text-base font-medium text-left text-[#3f434a]">
                    Budget strategy?
                </p>
                <div className="flex flex-col items-stretch">
                    <Radio.Group
                        className="mb-0"
                        onChange={(e) => {
                            let updates = {};
                            switch (e.target.value) {
                                case 'rateBased':
                                    updates.budget = null

                                    updates.target_rate = standardRate;
                                    break;
                                case 'costPerPeriodBased':

                                    updates.budget = 10000;
                                    updates.target_rate = null;
                                    break;
                            }
                            return onChangeBudgetInputs(updates);
                        }}
                        disabled={isDisabled || isProjectUpdating}
                        value={position.fixedRetainerBudgetType() || ''}
                        optionType="button"
                        buttonStyle="solid"
                    >
                        <div className="flex flex-row flex-wrap items-stretch">

                            <Radio value="costPerPeriodBased"
                                   className="flex flex-row items-start h-[unset] py-3 min-w-64 basis-1/3">
                                <div className="flex flex-row items-start gap-4">
                                    <div className="flex flex-col gap-1 items-stretch">
                                        <span className="text-sm font-semibold whitespace-nowrap">
                                            By Spend
                                        </span>
                                        <span className="text-[0.65rem] leading-normal whitespace-nowrap line-clamp-3">
                                            Cost per {frequencyDisplay[position.payout_frequency]}
                                        </span>
                                    </div>
                                </div>
                            </Radio>
                            <Radio value="rateBased"
                                   className="flex flex-row items-start h-[unset] py-3 min-w-64 basis-1/3">
                                <div className="flex flex-row items-start gap-4">
                                    <div className="flex flex-col gap-1 items-stretch">
                                        <span className="text-sm font-semibold whitespace-nowrap">
                                            By Hourly Rate
                                        </span>
                                        <span className="text-[0.65rem] leading-normal whitespace-nowrap line-clamp-3">
                                            By rate and hours per {frequencyDisplay[position.payout_frequency]}
                                        </span>
                                    </div>
                                </div>
                            </Radio>
                        </div>
                    </Radio.Group>
                </div>
            </div>

            {position.isFixedRetainerCostPerPeriodBased() && (
                <React.Fragment>
                    <FormInputComponent
                        type="hidden"
                        fieldName="budget"
                        required
                        min={1}
                        value={position.budget}
                    />
                    <FormInputComponent
                        type="hidden"
                        fieldName="actual_total_periods"
                        required
                        min={1}
                        max={500}
                        value={position.actual_total_periods}
                    />
                    <Input.Group compact>
                        <p className="self-center text-base font-medium text-left text-[#3f434a] whitespace-nowrap pr-4 leading-[40px]">
                            My initial budget is
                        </p>
                        <InputNumber
                            style={{width: '20%'}}
                            placeholder="10,000"
                            addonBefore="$"
                            min={1}
                            controls={false}
                            disabled={isDisabled || isProjectUpdating || !position.payout_frequency || !position.started_at}
                            size="large"
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            onChange={(e) => {
                                onChangeBudgetInputs({budget: e})
                            }}
                            value={position.budget || ''}
                            defaultValue={position.budget}
                        />
                        <p className="self-center text-base font-medium text-left text-[#3f434a] whitespace-nowrap px-4 leading-[40px]">
                            per {frequencyDisplay[position.payout_frequency] || 'week'} for
                        </p>
                        <InputNumber
                            style={{width: '10%'}}
                            placeholder="8"
                            max={500}
                            size="large"
                            controls={false}
                            disabled={isDisabled || isProjectUpdating || !position.payout_frequency || !position.started_at}
                            onChange={async (e) => {
                                onChangeBudgetInputs({actual_total_periods: e})
                            }}
                            value={position.actual_total_periods || ''}
                            defaultValue={position.actual_total_periods}
                            className="text-center"
                        />
                        <p className="self-center text-base font-medium text-left text-[#3f434a] whitespace-nowrap pl-4 leading-[40px]">
                            {position.payout_frequency && TB.pluralize(frequencyDisplay[position.payout_frequency], position.actual_total_periods || 2)}.
                        </p>
                    </Input.Group>

                </React.Fragment>
            )}
            {position.isFixedRetainerRateBased() && (
                <React.Fragment>
                    <FormInputComponent
                        type="hidden"
                        fieldName="target_rate"
                        required
                        min={1}
                        value={position.target_rate}
                    />
                    <FormInputComponent
                        type="hidden"
                        fieldName="avg_hours_per_period"
                        min={1}
                        max={position.payout_frequency === 'weekly' ? 40 : 200}
                        value={position.avg_hours_per_period}
                        required
                    />
                    <FormInputComponent
                        type="hidden"
                        fieldName="actual_total_periods"
                        required
                        min={1}
                        max={500}
                        value={position.actual_total_periods}
                    />
                    <Input.Group compact className="mb-6">
                        <p className="self-center text-base font-medium text-left text-[#3f434a] whitespace-nowrap pr-4 leading-[40px]">
                            Target Hourly Rate
                        </p>
                        <InputNumber
                            style={{minWidth: 200,width: '20%', maxWidth: 250}}
                            placeholder="100.00"
                            addonBefore="$"
                            min={1}
                            max={500}
                            precision={2}
                            disabled={isDisabled || isProjectUpdating || !position.fixedRetainerBudgetType() || !position.started_at}
                            size="large"
                            addonAfter=" per hour"
                            controls={false}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            onChange={(e) => {
                                onChangeBudgetInputs({target_rate: e})
                            }}
                            value={position.target_rate || ''}
                            defaultValue={position.target_rate}
                        />
                        <p className="text-secondary italic text-xs whitespace-nowrap leading-[40px] pl-3">
                            Standard rate for the roles selected is <b>{TB.formatCurrency(standardRate)}/hr</b>
                        </p>
                    </Input.Group>
                    <Input.Group compact className="mb-6">
                        <p className="self-center text-base font-medium text-left text-[#3f434a] whitespace-nowrap pr-4 leading-[40px]">
                            Expected availability is
                        </p>
                        <InputNumber
                            style={{minWidth: '10%', maxWidth: 230}}
                            placeholder={position.payout_frequency === 'weekly' ? '40' : (position.payout_frequency === 'monthly' ? '160' : '')}
                            addonAfter={`hours per ${frequencyDisplay[position.payout_frequency]}`}
                            min={1}
                            max={position.payout_frequency === 'weekly' ? 40 : 500}
                            value={position.avg_hours_per_period}
                            precision={0}
                            controls={false}
                            disabled={isDisabled || isProjectUpdating || !position.payout_frequency || !position.started_at}
                            size="large"
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            onChange={(e) => {
                                onChangeBudgetInputs({avg_hours_per_period: e})
                            }}
                            defaultValue={position.avg_hours_per_period}
                        />
                        <p className="self-center text-base font-medium text-left text-[#3f434a] whitespace-nowrap px-4 leading-[40px]">
                            for
                        </p>
                        <InputNumber
                            style={{width: '10%'}}
                            placeholder="8"
                            max={500}
                            size="large"
                            disabled={isDisabled || isProjectUpdating || !position.payout_frequency || !position.started_at}
                            onChange={(e) => {
                                onChangeBudgetInputs({actual_total_periods: e})
                            }}
                            value={position.actual_total_periods || ''}
                            defaultValue={position.actual_total_periods}
                            className="text-center"
                        />
                        <p className="self-center text-base font-medium text-left text-[#3f434a] whitespace-nowrap pl-4 leading-[40px]">
                            {position.payout_frequency && TB.pluralize(frequencyDisplay[position.payout_frequency], position.actual_total_periods || 2)}.
                        </p>
                    </Input.Group>
                </React.Fragment>
            )}


            <div className="bg-gray-100 rounded-lg py-8 px-3 flex flex-row items-center justify-center self-stretch my-8 gap-20">
                <Statistic
                    title={`${TB.capitalize(position.payout_frequency)} Retainer:`}
                    value={periodRetainer}
                    prefix="$"
                    loading={isLoadingPeriodRetainer || !periodRetainer}
                    className="bg-white border-secondary rounded-md px-5 py-4"
                    precision={2} />
                <Statistic
                    title="My Total Budget:"
                    value={totalBudget}
                    valueStyle={{color: TB.config('color.secondary'), fontWeight: 500}}
                    prefix="$"
                    loading={isLoadingTotalBudget || !totalBudget}
                    className="bg-white border-secondary rounded-md px-5 py-4"
                    precision={2} />
            </div>

            <p className="self-stretch text-base font-medium text-left text-[#3f434a]">
                What specific deliverables or activities will be part of this retainer?
            </p>
            <div className="flex flex-col justify-start items-stretch self-stretch relative gap-4">
                {isReadOnly ? CurrentPositionDeliverables : (
                    <Tabs items={TB.filter(tabs, tab => !!tab)}
                          activeKey={selectedTab}
                          onChange={setSelectedTab}/>
                )}
            </div>

            {!isReadOnly && editingDeliverable && (
                <ReactPortal wrapperId="react-portal-modal-container">
                    <Modal
                        okText={editingDeliverable?.id ? 'Update' : 'Save'}
                        title={editingDeliverable?.is_adding ? 'Add Deliverable' : (editingDeliverable?.id ? `Edit Deliverable` : `Create Deliverable`)}
                        className="project-scope-modal"
                        open={editModalOpen}
                        closable={false}
                        maskClosable={false}
                        destroyOnClose={true}
                        width={800}
                        footer={null}

                    >
                        {editingDeliverable && (
                            <PositionDeliverablesForm
                                submitBtn={(editingDeliverable?.is_adding || !editingDeliverable?.id) ? 'Add' : `Update`}
                                model={editingDeliverable}
                                onCancel={async () => {
                                    if (props.isDisabled || isProjectUpdating) {
                                        return
                                    }

                                    if (editingDeliverable?.is_adding || (!editingDeliverable?.id && !editingDeliverable.name)) {
                                        await toggleDeliverableForm(false);
                                        await TB.wait(300);
                                        return setEditingDeliverable(false);
                                    }
                                    await toggleDeliverableForm(false);
                                    await TB.wait(300);
                                    return setEditingDeliverable(false);
                                }}
                                onSubmit={async (params) => {

                                    let model = {...params, is_adding: undefined}
                                    let updatedDeliverables = [...positionDeliverables];

                                    if (params.is_adding) {
                                        updatedDeliverables.push(model)
                                    } else {
                                        updatedDeliverables = TB.map(updatedDeliverables, del => {
                                            if (model.id && del.id === model.id) {
                                                return model;
                                            } else if (model.deliverable_id && model.deliverable_id === del.deliverable_id) {
                                                return model;
                                            }
                                            return del;
                                        })
                                    }

                                    await toggleDeliverableForm(false)
                                    await TB.wait(300)
                                    await setSelectedTab('selected-deliverables');
                                    await onChange({deliverables: updatedDeliverables});
                                    await setEditingDeliverable(false)
                                }}/>
                        )}
                    </Modal>
                </ReactPortal>
            )}
        </div>
    );
};

PositionFixedRetainerForm.propTypes = {};

export default PositionFixedRetainerForm;